import { createSelector } from 'reselect';
const getSelectedInfoEntriesSource = (state) => state.domain.vehicleInfo.selectedInfoEntries;
export const getSelectedInfoEntries = createSelector([getSelectedInfoEntriesSource], result => result);
//# sourceMappingURL=getSelectedInfoEntries.js.map